/**
 * A React component that renders a dropdown menu and provides translation functionality.
 * @returns The rendered dropdown component.
 */
import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import Constant from "../../util/constant";

/**
 * Retrieves the username from the local storage if it exists.
 * @returns {object | undefined} The username object if it exists, otherwise undefined.
 */
const getUserName = () => {
  if (localStorage.getItem(Constant.LOCALSTORAGEKEYS.AUTHUSER)) {
    const obj = JSON.parse(localStorage.getItem(Constant.LOCALSTORAGEKEYS.AUTHUSER));
    return obj;
  }
};

function ProfileMenu(props) {
  const CLOUDINARY_URL =
    process.env.REACT_APP_CLOUDNARY_URL +
    process.env.REACT_APP_CLOUDNARY_NAME +
    process.env.REACT_APP_CLOUDNARY_SUBFLODER;

  /**
   * 
   * Initializes the component by setting up the necessary state variables and dependencies.
   * @param {object} props - The props object containing the necessary functions and data.
   * @returns None
   */
  const { handleLogout } = props;

  const { t } = useTranslation();

  const [name, setName] = useState(localStorage?.getItem(Constant.LOCALSTORAGEKEYS.FULLNAME));

  const convertName = name?.split(" ");

  /**
   * useEffect hook that retrieves the user data and sets the name state variable if the user data exists.
   * @returns None
   */
  useEffect(() => {
    const userData = getUserName();
    if (userData) {
      setName(userData?.username);
    }
  }, []);

  /**
   * Renders a dropdown menu component for the user profile.
   * @param {string} name - The name of the user.
   * @param {function} handleLogout - Function to handle user logout.
   * @returns {JSX.Element} - The rendered dropdown menu component.
   */
  return (
    <React.Fragment>
      <Dropdown
        className="d-inline-block profileDropdownStyle"
      >
        <Dropdown.Toggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
            { name === ''
              ?   <img className="rounded-circle header-profile-user"
                  src={CLOUDINARY_URL + 'user_avatr.png'}
                  alt="Header Avatar"
              /> 
              :
          <span className="rounded-circle header-profile-user nameProfile">{convertName === undefined ? '' : convertName[0]?.charAt(0)}</span>
   }
        
          <span className="d-xl-inline-block profileNamestyle">{name}</span>
          <i className="mdi mdi-chevron-down d-xl-inline-block font-size-20" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-end">
          <Dropdown.Item tag="a" onClick={handleLogout}>
            <i className="mdi mdi-exit-to-app font-size-24 align-middle text-danger" />
            <span>{t("LOGOUT")}</span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </React.Fragment>
  );
}

export default ProfileMenu;
